import { PopFeatureFlagsDto } from './pop-feature-flags.dto';

export class PopFeatureFlag {
  private static readonly key = 'flag_';

  private static getKey(key: string) {
    return `${this.key}${key}`;
  }

  public constructor(public key: keyof PopFeatureFlagsDto, public defaultValue: boolean) {}

  public get value(): boolean {
    const override = this.getFeatureFlagOverride(this.key);
    if (override !== null) {
      return override;
    }
    return this.defaultValue;
  }

  public set value(v: boolean) {
    if (this.defaultValue === v) {
      this.setFeatureFlagOverride(this.key, null);
    } else {
      this.setFeatureFlagOverride(this.key, v);
    }
  }

  private getFeatureFlagOverride(key: keyof PopFeatureFlagsDto) {
    const storageValue = localStorage.getItem(PopFeatureFlag.getKey(key));
    if (storageValue == null) {
      return null;
    }
    return storageValue === true.toString();
  }

  public setFeatureFlagOverride(key: keyof PopFeatureFlagsDto, value: boolean | null) {
    if (value == null) {
      localStorage.removeItem(PopFeatureFlag.getKey(key));
      return;
    }
    localStorage.setItem(PopFeatureFlag.getKey(key), value.toString());
  }
}
